<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        Enfermagem
        <span v-if="attendancePlace" class="font-weight-light">
          / {{ attendancePlace.name }}
        </span>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-tabs background-color="transparent" color="gray">
          <authorization permissionKey="island_identification_queue" can="read">
            <v-tab
              :to="`/filas/enfermagem/${attendancePlaceId}/identificacao`"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Identificação"
                queueType="identification"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="island_pre_exam_queue" can="read">
            <v-tab
              :to="`/filas/enfermagem/${attendancePlaceId}/pre-exames`"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Pré-exames"
                queueType="pre_exam"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="island_therapy_queue" can="read">
            <v-tab
              :to="`/filas/enfermagem/${attendancePlaceId}/terapeutica`"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Dilatação/Terapêutica"
                queueType="therapy"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>

          <authorization permissionKey="island_attendances_queue" can="read">
            <v-tab
              :to="`/filas/enfermagem/${attendancePlaceId}/consultas`"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Consultas"
                queueType="doctor"
                :attendancePlaceId="attendancePlaceId"
              />
            </v-tab>
          </authorization>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <router-view :attendancePlace="attendancePlace" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";
export default {
  name: "island",
  components: {
    PatientsCounter,
  },
  props: {
    attendancePlaceId: String,
  },
  apollo: {
    attendancePlace: {
      query: require("@/graphql/attendance_place/attendance_place.gql"),
      variables() {
        return {
          attendancePlaceId: this.attendancePlaceId,
        };
      },
    },
  },
};
</script>

<style lang="sass" scoped></style>
